import { Grid, Paper, styled, Typography } from "@mui/material";

const PREFIX = "AssignmentsDashboardPageSummaryCard";

const classes = {
	countPaper: `${PREFIX}-countPaper`,
	count: `${PREFIX}-count`,
	countNum: `${PREFIX}-countNum`,
};

const StyledGrid = styled(Grid)(({ theme }) => ({
	[`& .${classes.countPaper}`]: {
		minHeight: 100,
		marginBottom: theme.spacing(5),
		marginRight: theme.spacing(3),
		padding: theme.spacing(5),
		paddingTop: theme.spacing(2),
		minWidth: "240px",
	},

	[`& .${classes.count}`]: {
		color: theme.palette.text.secondary,
		paddingBottom: theme.spacing(2),
	},

	[`& .${classes.countNum}`]: {
		fontWeight: "bold",
		fontSize: "1.5rem",
	},
}));

export interface SummaryCardProps {
	children: string;
	count: number;
}

export const SummaryCard = ({
	children,
	count,
}: SummaryCardProps): JSX.Element => {
	return (
		<StyledGrid item>
			<Paper className={classes.countPaper}>
				<Typography className={classes.count}>{children}</Typography>
				<Typography className={classes.countNum}>{count}</Typography>
			</Paper>
		</StyledGrid>
	);
};
